import { makeImmutable } from "../../core";
/**
 * A container for products and modifiers.
 *
 * For example: a cardboard box for pizzas.
 */
export class PackagingContainerType {
    constructor(params) {
        this.id = params.id;
        this.capacity = params.capacity;
        this.price = params.price;
        this.allowedProductTypes = params.allowedProductTypes;
        this.allowedModifierItemTypes = params.allowedModifierItemTypes;
        makeImmutable(this);
    }
    /**
     * Whether this container may hold the subject at all, capacity aside.
     *
     * This is the client's side of the backend's `anyAllowedContainers`: a
     * subject no container allows is one the backend reports no packaging demand
     * for, so it is not packaged rather than unpackable.
     */
    allows(subject) {
        var _a, _b;
        switch (subject.type) {
            case "ProductInstance":
                return subject.packagedProductTypeIds.isSubsetOf(this.allowedProductTypes);
            case "ModifierItem":
                return ((_b = (_a = this.allowedModifierItemTypes
                    .find(subject.modifierTypeId)) === null || _a === void 0 ? void 0 : _a.includes(subject.modifierItemTypeId)) !== null && _b !== void 0 ? _b : false);
        }
    }
    canContain(subject) {
        if (subject.volume.compare(this.capacity) > 0) {
            // NOTICE If base volume exceeds container capacity it impossible and invalid menu configuration
            return false;
        }
        return this.allows(subject);
    }
}
export const PackagingContainerTypes = "PackagingContainerTypes";
